import React, { Component } from 'react'
import { get } from 'lodash'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'

import { Button, SuccessBadges } from 'components/misc'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import config from 'config'

@connect(({ auth }) => ({
  user: auth.user
}))
class Success extends Component {
  static propTypes = {
    user: PropTypes.object
  }
  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h1 className="beta">
            <span
              className="ico ico--checked"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.your_registration_is_complete"
              defaultMessage="Your registration is complete"
            />
          </h1>
          <h2 className="reset-margin--top">
            <span
              className="ico ico--email"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.we_have_sent_you_an_email"
              defaultMessage="We have sent you an email with an activation link."
            />
          </h2>
          <p className="desc">
            <FormattedHTMLMessage
              id="label.youll_receive_a_notification"
              defaultMessage="You'll receive a notification when your Award Leader has approved your registration. You can log on to the ORB Next Generation <a>here</a> (until your Award leader has approved your registration you will only have limited functionality)."
            />
          </p>
          <SuccessBadges />

          {get(this.props.user, 'access_token') && (
            <Button link to={`${config.publicPath}/dashboard`}>
              <FormattedMessage
                id="button.continue_to_award"
                defaultMessage="Continue to award"
              />
            </Button>
          )}
          {!get(this.props.user, 'access_token') && (
            <Button link to={`${config.publicPath}/`}>
              <FormattedMessage
                id="button.continue"
                defaultMessage="Continue"
              />
            </Button>
          )}
        </div>
      </div>
    )
  }
}

export default Success
